import fbtemplate from './builder/preview.html';
import controller from './form.controller';
import template from './form.html';
import angular from 'angular';
import GridUtils from '../../utils/kform-grid-utils';

const formConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('form', {
		title:      'Form',
		template,
		group:      'advanced',
		settings:   {
			clearOnHide: true,
			kdata:       {
				create:   null,
				node_kid: null,
				path:     [],
				rg:       null,
			},
			input:       true,
			key:         'formField',
			label:       '',
			persistent:  true,
		},
		selectable: true,
		controller,
		/**
		 * @param {any} data
		 * @param {any} options
		 * @returns {string}
		 */
		tableView:  (data, options) => {
			// Include only form data.
			return data ? GridUtils.generic(data.data, options) : '';
		},
		fbtemplate,
		icon:       'fa fa-wpforms',
		views:      [
			{
				name:     'Display',
				template: 'kform/components/form/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/common/data.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
	});
};

export default angular.module('app')
	.config(formConfig);
